import { render } from "./LogoComponent.vue?vue&type=template&id=2f3c49a2"
import script from "./LogoComponent.vue?vue&type=script&lang=js"
export * from "./LogoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__